import { toast } from '@/hooks/use-toast';

export const showToast = {
  success: (message: string, description?: string) => {
    toast({
      title: message,
      description,
      variant: 'default',
    });
  },
  
  error: (message: string, description?: string) => {
    toast({
      title: message,
      description,
      variant: 'destructive',
    });
  },
  
  info: (message: string, description?: string) => {
    toast({
      title: message,
      description,
      variant: 'default',
    });
  },
  
  warning: (message: string, description?: string) => {
    toast({
      title: message,
      description,
    });
  },

  // Specific toast messages for common operations
  ticketCreated: (ticketNumber: number) => {
    toast({
      title: 'Ticket Created',
      description: `Ticket #${ticketNumber} has been created successfully`,
      variant: 'default',
    });
  },

  ticketUpdated: (ticketNumber: number) => {
    toast({
      title: 'Ticket Updated',
      description: `Ticket #${ticketNumber} has been updated successfully`,
      variant: 'default',
    });
  },

  commentAdded: () => {
    toast({
      title: 'Comment Added',
      description: 'Your comment has been added successfully',
      variant: 'default',
    });
  },

  attachmentUploaded: (count: number) => {
    toast({
      title: 'Attachment Uploaded',
      description: `${count} attachment${count > 1 ? 's' : ''} uploaded successfully`,
      variant: 'default',
    });
  },

  networkError: () => {
    toast({
      title: 'Connection Error',
      description: 'Unable to connect to the server. Please check your connection.',
      variant: 'destructive',
    });
  }
};